import { render, staticRenderFns } from "./UpdateCheck.vue?vue&type=template&id=1d811125&"
import script from "./UpdateCheck.vue?vue&type=script&lang=js&"
export * from "./UpdateCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports